import axios from 'axios'

const accessToken = localStorage.getItem('accessToken')
const refreshToken = localStorage.getItem('refreshToken')

axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`

// If the API ever comes back with a 401 (expired or invalid token - e.g. a
// credential rotation, or the token simply aging out), the token in
// localStorage is stale and every subsequent call will keep failing the same
// way. Rather than letting each screen silently render an empty state (which
// looked like all data had been wiped after a past JWT secret rotation),
// clear the stale token and send the user back to a real login.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/auth/login') {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      window.location.href = '/auth/login'
    }
    return Promise.reject(error)
  }
)

const config = {
  MUNROE_BUCKET_NAME: process.env.REACT_APP_MUNROE_BUCKET,
  axios: axios,
}

export default config
